import { ContextModalProps } from '@mantine/modals'
import PlaceConfigForm from 'components/place/PlaceConfigForm'
import { useAddRack } from 'hooks/places'
import { PlaceConfig } from 'types/places'

export default function AddRackModal({ context, id }: ContextModalProps) {
  const addRack = useAddRack()
  async function submit(values: PlaceConfig) {
    await addRack.mutateAsync(values)
  }

  return <PlaceConfigForm onSubmit={submit} onCancel={() => context.closeModal(id)} />
}
